import { connect } from 'react-redux'
import activityGroupSelector from './activityGroupSelector'
import ActivityGroup from './ActivityGroup'

export default connect(
  activityGroupSelector,
  {},
  null,
  {
    forwardRef: true
  }
)(ActivityGroup)
